module.exports = __webpack_public_path__ + "static/media/spa-flag.00a1c321.svg";